import { store } from '../redux/initStore';
import { useAppSelector } from '../redux/store';

export type IfAppIsActivatedProps = {
    dependency: string;
    children: JSX.Element;
};

export const IfAppIsActivated = (props: IfAppIsActivatedProps) => {
    const { isDependencyActivated } = useAppSelector((state) => {
        return {
            isDependencyActivated: store.selectors.application.selectById(state, props.dependency),
        };
    });
    return isDependencyActivated ? props.children : null;
};
